//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ImageUploader from "../../../components/ImageUploader";

export default {
    name: "create-workOrder",
    components: {ImageUploader},
    data() {
        return {
            loading: false,
            saving: false,
            workOrderDto: {
                id: 0,
                workOrderType: 2,
                repairType: 0,
                image: {},
                projectId: 0,
                projectName: '',
                projectStages: '',
                roomStructureName: '',
                chamberName: '',
                roomId: 0,
                roomNumber: '',
                memberId: 0,
                name: '',
                mobile: '',
                content: '',
            },
            currentBindUser: {id: 0, memberId: 0, userId: 0,},
            sourcePopup: false,
            sources: [
                {text: '客服热线', value: 1},
                {text: '集团400电话', value: 2},
                {text: '现场接待', value: 3},
                {text: '区域400电话', value: 4},
                {text: '小悦', value: 4},
                {text: '交房验房', value: 4},
                {text: '其他', value: 9},
            ],
            projectPopup: false,
            projectColumns: [],
            projectStagePopup: false,
            projectStages: [],
            roomStructurePopup: false,
            roomStructures: [],
            chamberPopup: false,
            chambers: [],
            roomPopup: false,
            rooms: [],
            roomMemberList: [],
            radio: null,
            createMemberFamilyDto: {},
            createMemberPopup: false
        }
    },
    methods: {
        getCurrentUserByMember() {
            abp.ajax.get('/api/services/app/WorkOrder/GetCurrentUserByMember').then(res => {
                if (res.data.result != null) {
                    this.currentBindUser = res.data.result;
                    this.getUserProjects();
                }
            })
        },

        onSave() {
            const vm = this;
            this.workOrderDto.reportId = this.currentBindUser.userId;
            if (this.workOrderDto.source === undefined) {
                this.$toast('请选择来源')
                return
            }
            if (this.workOrderDto.repairType === 0 && (this.workOrderDto.roomId === 0 || this.workOrderDto.roomId === undefined)) {
                this.$toast("室内请选择房号")
                return;
            }
            if (!this.workOrderDto.name) {
                this.$toast('请输入联系人')
                return
            }
            if (!this.workOrderDto.mobile) {
                this.$toast('请输入联系电话')
                return
            }
            if (!this.workOrderDto.content) {
                this.$toast('请输入内容')
                return
            }
            this.workOrderDto.dataSource = 4;

            // <van-cell title="项目" v-model="workOrderDto.projectName" @click="projectPopup=true" is-link/>
            //     <van-cell title="分期" v-model="workOrderDto.projectStages" @click="projectStagePopup=true" is-link/>
            //     <van-cell title="楼栋" v-model="workOrderDto.roomStructureName" @click="roomStructurePopup=true" is-link/>
            //     <van-cell title="单元" v-model="workOrderDto.chamberName" @click="chamberPopup=true" is-link/>
            //     <van-cell title="房号" v-model="workOrderDto.roomNumber" @click="roomPopup=true" is-link/>
            vm.workOrderDto.roomNum = this.workOrderDto.projectStages;
            if (this.workOrderDto.roomStructureName) {
                vm.workOrderDto.roomNum = vm.workOrderDto.roomNum + ' / ' + this.workOrderDto.roomStructureName;
                if (this.workOrderDto.chamberName) {
                    vm.workOrderDto.roomNum = vm.workOrderDto.roomNum + ' / ' + this.workOrderDto.chamberName;
                    if (this.workOrderDto.roomNumber) {
                        vm.workOrderDto.roomNum = vm.workOrderDto.roomNum + ' / ' + this.workOrderDto.roomNumber;
                    }
                }
            }
            // console.log(this.workOrderDto);
            // return;

            vm.saving = true;
            this.$store.dispatch({
                type: 'workOrder/saveWorkOrder',
                data: vm.workOrderDto
            }).then(() => {

                vm.$dialog.confirm({
                    title: '提示',
                    message: '提交成功',
                    showCancelButton: false
                }).then(() => {
                    // vm.$router.back()
                })

            }).finally(() => {
                vm.saving = false;
            });

        },

        getUserProjects() {
            abp.ajax.get('/api/services/app/Project/GetProjectList?userId=' + this.currentBindUser.userId).then(res => {
                if (res.data.result != null) {
                    this.projectColumns = []
                    this.projectColumns.push(...res.data.result);
                    this.projectColumns.forEach(item => {
                        item.text = item.name;
                    })
                    if (this.projectColumns.length === 1) {
                        this.onProjectConfirm(this.projectColumns[0]);
                    }
                }
            })
        },


        onSourceConfirm(data, index) {
            console.log(data)
            this.workOrderDto.source = data.value;
            this.workOrderDto.sourceStr = data.text;
            this.sourcePopup = false;
        },
        onProjectConfirm(data, index) {
            if (data.id !== this.workOrderDto.projectId) {
                console.log("-----------------")
                this.projectStages = [];
                this.roomStructures = [];
                this.chambers = [];
                this.rooms = [];
                this.workOrderDto.projectStages = '';
                this.workOrderDto.roomStructureName = '';
                this.workOrderDto.chamberName = '';
                this.workOrderDto.roomId = 0
                this.workOrderDto.roomNumber = '';
                this.resetMember();

                this.workOrderDto.projectId = data.id;
                this.workOrderDto.cityId = data.cityId;
                this.workOrderDto.cityName = data.cityName;
                this.workOrderDto.projectName = data.text;
                this.projectPopup = false;
                this.getProjectStages();
            }
            this.projectPopup = false;
        },

        /*分期*/
        getProjectStages() {
            if (this.workOrderDto.projectId <= 0 || this.workOrderDto.projectId === undefined) {
                return
            }
            abp.ajax.get('/api/services/app/Project/GetProjectStages?projectId=' + this.workOrderDto.projectId).then(res => {
                this.projectStages = [];
                this.projectStages.push(...res.data.result.items);
                this.projectStages.forEach(item => {
                    item.text = item.key;
                    item.children = null;
                })
                // if (this.projectStages.length === 1) {
                //     this.onProjectStageConfirm(this.projectStages[0]);
                // }
            }).finally(() => {
                this.loading = false;
            });
        },

        onProjectStageConfirm(data, index) {
            if (data.text !== this.workOrderDto.projectStages) {
                // this.projectStages = [];
                this.roomStructures = [];
                this.chambers = [];
                this.rooms = [];
                // this.workOrderDto.projectStages = '';
                this.workOrderDto.roomStructureName = '';
                this.workOrderDto.chamberName = '';
                this.workOrderDto.roomId = 0
                this.workOrderDto.roomNumber = '';
                this.resetMember();

                this.workOrderDto.projectStages = data.text;
                this.getLouDongs();
            }
            this.projectStagePopup = false;
        },

        getLouDongs(key) {
            this.loading = true;
            abp.ajax.get('/api/services/app/Project/GetLouDong?projectId=' + this.workOrderDto.projectId + '&fenqiName=' + this.workOrderDto.projectStages).then(res => {
                this.roomStructures = [];
                this.roomStructures.push(...res.data.result);
                this.roomStructures.forEach(item => {
                    item.text = item.key;
                    item.children = null;
                })
                // if (this.roomStructures.length === 1) {
                //     this.onRoomStructureConfirm(this.roomStructures[0]);
                // }
            }).finally(() => {
                this.loading = false;
            });
        },
        onRoomStructureConfirm(data, index) {
            if (data.text !== this.workOrderDto.roomStructureName) {

                // this.projectStages = [];
                // this.roomStructures = [];
                this.chambers = [];
                this.rooms = [];
                // this.workOrderDto.projectStages = '';
                // this.workOrderDto.roomStructureName = '';
                this.workOrderDto.chamberName = '';
                this.workOrderDto.roomId = 0
                this.workOrderDto.roomNumber = '';
                this.resetMember();

                this.workOrderDto.roomStructureName = data.text;

                this.getDanYuan()
            }
            this.roomStructurePopup = false;
        },

        getDanYuan(projectId, name) {
            let page = {
                projectId: this.workOrderDto.projectId,
                fenqi: this.workOrderDto.projectStages,
                loudongName: this.workOrderDto.roomStructureName
            };

            abp.ajax.get('/api/services/app/Project/GetDanYuanList', {
                params: page
            }).then(res => {
                this.chambers = [];
                this.chambers.push(...res.data.result);
                this.chambers.forEach(item => {
                    item.text = item.key;
                    item.children = null;
                })
                // if (this.chambers.length === 1) {
                //     this.onChamberConfirm(this.chambers[0]);
                // }
            }).finally(() => {

            });
        },
        onChamberConfirm(data, index) {
            if (data.text !== this.workOrderDto.chamberName) {

                // this.projectStages = [];
                // this.roomStructures = [];
                // this.chambers = [];
                this.rooms = [];
                // this.workOrderDto.projectStages = '';
                // this.workOrderDto.roomStructureName = '';
                // this.workOrderDto.chamberName = '';
                this.workOrderDto.roomId = 0
                this.workOrderDto.roomNumber = '';
                this.resetMember();

                this.workOrderDto.chamberName = data.text;

                this.getRooms();
            }
            this.chamberPopup = false;
        },

        getRooms() {
            var page = {
                projectId: this.workOrderDto.projectId,
                projectStages: this.workOrderDto.projectStages,
                roomStructureName: this.workOrderDto.roomStructureName,
                chamberName: this.workOrderDto.chamberName
            };
            abp.ajax.get('/api/services/app/Project/GetRoomList', {params: page}).then(res => {
                this.rooms = [];
                this.rooms.push(...res.data.result);
                this.rooms.forEach(item => {
                    item.text = item.roomNumber;
                })
                if (this.rooms.length === 1) {
                    this.onRoomConfirm(this.rooms[0]);
                }
            }).finally(() => {

            });
        },
        onRoomConfirm(data, index) {
            if (data.id !== this.workOrderDto.roomId) {

                // this.projectStages = [];
                // this.roomStructures = [];
                // this.chambers = [];
                // this.rooms = [];
                // this.workOrderDto.projectStages = '';
                // this.workOrderDto.roomStructureName = '';
                // this.workOrderDto.chamberName = '';
                // this.workOrderDto.roomId = 0
                // this.workOrderDto.roomNumber = '';
                this.resetMember();

                this.workOrderDto.roomNumber = data.text;
                this.workOrderDto.roomId = data.id;
                this.roomPopup = false;
                this.getOwnersByRoomId();
            }
            this.roomPopup = false;
        },

        resetMember() {
            this.roomMemberList = [];
            this.workOrderDto.memberId = 0;
            this.workOrderDto.name = '';
            this.workOrderDto.mobile = '';
        },
        getOwnersByRoomId() {
            const vm = this;
            vm.workOrderDto.memberId = 0;
            vm.workOrderDto.name = '';
            vm.workOrderDto.mobile = '';
            abp.ajax.get('/api/services/app/NewOwner/GetAllRoomMember?roomId=' + this.workOrderDto.roomId).then(res => {
                vm.roomMemberList = [];
                vm.roomMemberList.push(...res.data.result);
                if (vm.roomMemberList.length === 1) {
                    let data = vm.roomMemberList[0];
                    vm.workOrderDto.memberId = data.memberId;
                    vm.workOrderDto.name = data.member.name;
                    vm.workOrderDto.mobile = data.member.phoneNumber;
                    vm.onCheckedMember(data);

                    // vm.$set(vm.workOrderDto, 'name', data.member != null ? data.member.name : '');
                    // vm.$set(vm.workOrderDto, 'mobile', data.member != null ? data.member.phoneNumber : '');
                }
            });
        },
        onCheckedMember(row) {
            this.radio = row.id;
            this.workOrderDto.memberId = row.memberId;
            this.workOrderDto.name = row.member.name;
            this.workOrderDto.mobile = row.member.phoneNumber;
        },
        editCreateMember() {
            this.createMemberFamilyDto = {
                type: 10
            }
            this.createMemberPopup = true;
        },
        /*保存房子关联人员*/
        onSaveMemberFamily() {
            this.createMemberFamilyDto.roomId = this.workOrderDto.roomId;
            if (this.createMemberFamilyDto.roomId === undefined || this.createMemberFamilyDto.roomId <= 0) {
                this.$toast('请先选择房源');
                return;
            }
            if (!this.createMemberFamilyDto.name) {
                this.$toast('请输入姓名');
                return;
            }
            if (!this.createMemberFamilyDto.phoneNumber) {
                this.$toast('请输入联系电话');
                return;
            }
            this.saving = true;
            abp.ajax.post('/api/services/app/CallLogs/CreateMemberFamily', this.createMemberFamilyDto).then(res => {
                this.createMemberPopup = false;
                this.getOwnersByRoomId();
            }).finally(() => {
                this.saving = false;
            });
        },


    },
    created() {
        this.getCurrentUserByMember();
    }
}
